import axios from '@/plugins/axios.js';
import SnackbarService from '@/services/SnackbarService.js';

export default {
    namespaced: true,

    state() {
        return {
            isImpersonating: false,
            impersonator: null,
            isStartingImpersonation: false,
            isStoppingImpersonation: false,
        };
    },

    getters: {
        isImpersonating: state => state.isImpersonating,
        impersonator: state => state.impersonator,
        isStartingImpersonation: state => state.isStartingImpersonation,
        isStoppingImpersonation: state => state.isStoppingImpersonation,
        isTransitioningImpersonation: state => state.isStartingImpersonation || state.isStoppingImpersonation,
    },

    actions: {
        hydrate({ commit }, data) {
            if (data) {
                commit('SET_IS_IMPERSONATING', data.isImpersonating || false);
                commit('SET_IMPERSONATOR', data.impersonator || null);
            }
        },

        async startImpersonation({ commit, getters }, userId) {
            if (getters.isTransitioningImpersonation) {
                return null;
            }

            commit('SET_IS_STARTING_IMPERSONATION', true);

            try {
                const { data } = await axios.post(`/api/impersonate/${userId}/start`, {}, { errorHandle: false });

                // Redirect to home — the impersonated user may not have access to the current page
                window.location.href = '/';

                return data;
            } catch (error) {
                commit('SET_IS_STARTING_IMPERSONATION', false);

                SnackbarService.open({
                    message: error?.response?.data?.message || 'Unable to start impersonation.',
                    type: 'is-danger',
                });

                return null;
            }
        },

        async stopImpersonation({ commit, getters }) {
            if (getters.isStoppingImpersonation) {
                return null;
            }

            commit('SET_IS_STOPPING_IMPERSONATION', true);

            try {
                const { data } = await axios.post('/api/impersonate/stop', {}, { errorHandle: false });

                // A redirect swallowed by the browser (e.g. forced-survey middleware) resolves with the
                // SPA HTML shell instead of the expected JSON payload — treat it as a failure, not success
                if (!data || typeof data !== 'object' || !data.message) {
                    throw new Error('Unexpected response while stopping impersonation.');
                }

                // Redirect to home — the current page may not be accessible to the original admin user's view
                window.location.href = '/';

                return true;
            } catch (error) {
                commit('SET_IS_STOPPING_IMPERSONATION', false);

                SnackbarService.open({
                    message: error?.response?.data?.message || 'Unable to stop impersonation.',
                    type: 'is-danger',
                });

                return null;
            }
        },
    },

    mutations: {
        SET_IS_IMPERSONATING(state, value) {
            state.isImpersonating = value;
        },

        SET_IMPERSONATOR(state, value) {
            state.impersonator = value;
        },

        SET_IS_STARTING_IMPERSONATION(state, value) {
            state.isStartingImpersonation = value;
        },

        SET_IS_STOPPING_IMPERSONATION(state, value) {
            state.isStoppingImpersonation = value;
        },
    },
};
